
'use strict';


import {langUrl} from './lib/lang-url';

import fixProductsAlignment from './modules/fix-product-alignment';
import fixIframeRatio from './modules/fix-iframe-ratio';
import validateForm from './modules/validate';
import itemPagination from './modules/item-pagination';
import insertTableRow from './modules/insert-table-row';
import zipCheck from './modules/zipcheck';
import vatCheck from './modules/vat-check';
import {recaptchaTokenCreate, recaptchaTokenRefresh} from './modules/recaptcha';
import { setupAccountDelete } from './modules/account';
import setupProductOverview from './modules/product-overview';
import setupCheckout from './modules/checkout';
import setupCart from './modules/cart';
import setupMiniCart from './modules/minicart';
import setupGA4 from './modules/ga4';
import setupReferences from './modules/references';
import setupStockNotificationForm from './modules/stock-notification-form';

import BaptistSlider from './elements/baptist-slider';
import BaptistProduct from './elements/baptist-product';

import $ from 'jquery';

import ProductStore from './store/product';
import { setupAnchorScroll, scrollToAnchor } from "./modules/anchorScroll.js";
import setupAddToCart from './modules/add-to-cart';
import {OjEventManager} from './modules/ojevent';


window.store = {};
window.store.product = new ProductStore();

window.checkoutEventManager = new OjEventManager();




window.addEventListener('DOMContentLoaded', setupCheckout);
window.addEventListener('DOMContentLoaded', setupCart);
window.addEventListener('DOMContentLoaded', setupMiniCart);
window.addEventListener('DOMContentLoaded', setupGA4);
window.addEventListener('DOMContentLoaded', setupReferences);
window.addEventListener('DOMContentLoaded', setupStockNotificationForm);


window.customElements.define('baptist-slider', BaptistSlider);
window.customElements.define('baptist-product', BaptistProduct);






require('./modules/oneToMarket.js');
require('./modules/loginForm.js');
require('./modules/foldMenu.js');
require('./modules/imageGallery.js');
require('./modules/toggle.js');
require('./modules/newsletter.js');
require('./modules/favorites.js');
require('./modules/forgotPassForm.js');
require('./modules/searchFooter.js');


require('./modules/header.js');
require('./modules/vergelijk.js');
require('./modules/search.js');



window.addEventListener('DOMContentLoaded', setupAddToCart);

window.addEventListener('DOMContentLoaded', setupAnchorScroll);
window.addEventListener('resize', setupAnchorScroll);

window.addEventListener('load', scrollToAnchor);
window.addEventListener('hashchange', scrollToAnchor);



$(function () {

    recaptchaTokenCreate();

    setInterval(function () {
        recaptchaTokenRefresh();
    }, 110 * 1000);

    $('.orders #table_id .edit').on('click', insertTableRow);






    $('label.toggleable-radio span').on("click", function (evt) {
        const $radio = $(this).prev('input');

        if ( $radio.prop('checked') === true ) {
            evt.preventDefault();
            $radio.prop('checked', false);
            $radio.trigger('change');
        } else {
            evt.preventDefault();
            $radio.prop('checked', true);
            $radio.trigger('change');
        }

        // Trigger change event
        const event = new Event('change');
        $radio.get(0).dispatchEvent(event);
    });





    $('.image-gallery').lightGallery({
        selector: 'img',
        actualSize: false,
        autoplayControls: false
    });


    setupAccountDelete();
});


window.addEventListener('DOMContentLoaded', fixProductsAlignment);
window.addEventListener('resize', fixProductsAlignment);
window.addEventListener('showProduct', fixProductsAlignment);


window.addEventListener('DOMContentLoaded', fixIframeRatio);
window.addEventListener('resize', fixIframeRatio);



function beforeCheckoutSubmit () {
    window.checkoutEventManager.trigger();
}



window.addEventListener('DOMContentLoaded', () => {
    validateForm({
        validateEndpoint: '/ajax/checkout/validateForm',
        insertEndpoint: langUrl('/checkout/finish'),
        submitSelector: 'button.checkout',
        beforeSubmit: beforeCheckoutSubmit,
        ajax: false,
    })('.checkout .customer-form', '.checkout .payment form', '.checkout .confirm-order form');

    validateForm({
        validateEndpoint: '/ajax/customer/validateForm',
        insertEndpoint: langUrl('/customer/registrate'),
        ajax: false,
        messageSelector: '.message',
    })('#register .customer-form');

    validateForm({
        validateEndpoint: '/ajax/customer/validateForm',
        insertEndpoint: '/ajax/customer/update',
        ajax: true,
        messageSelector: '.message',
    })('.account .customer-info');

    validateForm({
        validateEndpoint: '/ajax/customer/validatePassword',
        insertEndpoint: '/ajax/customer/changePass',
        ajax: true,
        messageSelector: '.message',
        hideOnSuccess: false,
    })('.account #password-form');

    validateForm({
        validateEndpoint: '/ajax/review/validateForm',
        insertEndpoint: '/ajax/review/insert',
        ajax: true,
        messageSelector: '.form_output > div'
    })('.review-form');

    validateForm({
        validateEndpoint: '/ajax/customer/validateCreatePassword',
        insertEndpoint: '/ajax/customer/createNewPassword',
        ajax: true,
        messageSelector: '.message',
        hideOnSuccess: false,
    })('.reset-password .new-password-form');
});





itemPagination({
    selector: '.agenda-items',
    template: require('./template/agenda/agenda.hbs')
});

itemPagination({
    selector: '.customer-items',
    template: require('./template/werkvanklanten/showcase.hbs')
});







window.addEventListener('DOMContentLoaded', () => {
    zipCheck('form');
});

window.addEventListener('DOMContentLoaded', () => {
    vatCheck('#customer-vat');
});




window.addEventListener('DOMContentLoaded', setupProductOverview);






class RedirectDropDown extends HTMLElement {

    connectedCallback () {
        this.querySelector('select')
            .addEventListener('change', evt => {
                window.location.replace(evt.target.value);
            });
    }

}
window.customElements.define('redirect-dropdown', RedirectDropDown);





$('input.quantity.type-giftCard').on('change', function() {
  if ( this.validity.rangeUnderflow ) {
    this.setCustomValidity($(this).data("min-message"));
  } else if ( this.validity.rangeOverflow ) {
    this.setCustomValidity($(this).data("max-message"));
  } else if ( this.validity.valueMissing ) {
    this.setCustomValidity("Required");
  } else {
    this.setCustomValidity("");
  }
});
